
/* injects from baggage-loader */
var Template = require('./template.js');
require('./style.scss');

import { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { UIMixin } from "../../../mixins/uiMixin";
import { createSelector } from "reselect";
import { ConfirmRegistrationNewCard, RegisterMode, ClearCardRegistered } from "../../../actions/terminal";
import Zergling from '../../../helpers/zergling';
import Helpers from '../../../helpers/helperFunctions';
import { OpenPopup, ClosePopup } from "../../../actions/ui";
import { store } from "../../../index/terminalApp";
import { FinishRegistration } from "../../../actions/user";
import Config from "../../../config/main";
import { getSwarmSetRfidPinCodeRequest } from "../../../helpers/terminalRequests/rfid";

export function registerFromCSharp(params, isSuccess) {
    let token = JSON.parse(sessionStorage.getItem("authData")).token,
        data = JSON.parse(params),
        textForSuccess = 'Card succesfully registered',
        textCode;

    if (!isSuccess) return;

    Zergling.get({
        "token": token,
        "user_info": {
            "FirstName": data.Name,
            "LastName": data.Surname,
            "Email": data.Email,
            "DocNumber": data.CNP,
            "MobileNumber": data.Phone,
            "RFID": data.CardId,
            "BTag": data.BTag,
            "CurrencyId": "RON",
            "RegionId": 189
        }
    }, "terminal_create_player")
        .then(async (response) => {
            textCode = response.text_code;
            if (response.text_code === "0") {
                if (Config.main.rfidPinCode) {
                    const params = {
                        PinCode: '0000',
                        Rfid: data.CardId,
                    }

                    await Zergling.get(getSwarmSetRfidPinCodeRequest(params), 'betshop_command');
                }
                store.dispatch(FinishRegistration(true));
                store.dispatch(OpenPopup('dmsSuccess', { body: textForSuccess }));
            } else {
                store.dispatch(FinishRegistration(false));
                store.dispatch(OpenPopup('failPopup', { textCode }));
            }
        })
        .catch(error => console.warn(error));
}

class DmsRegisterFields extends Component {
    constructor(props) {
        super(props);
        this.state = {
            Name: '',
            Surname: '',
            CNP: '',
            Phone: '',
            Email: '',
            isChecked: false,
            // isPinCodeFormValid: !Config.main.rfidPinCode,
        };
        this.confirmRegistration = this.confirmRegistration.bind(this);
        this.handleNameChange = this.handleNameChange.bind(this);
        this.handleSurNameChange = this.handleSurNameChange.bind(this);
        this.handleCnpChange = this.handleCnpChange.bind(this);
        this.handlePhoneChange = this.handlePhoneChange.bind(this);
        this.handleEmailChange = this.handleEmailChange.bind(this);
        this.handleChecked = this.handleChecked.bind(this);
        this.handleBTagChange = this.handleBTagChange.bind(this);
        this.isInputValid = this.isInputValid.bind(this);
        this.registerPopupForDms = this.registerPopupForDms.bind(this);
        this.validateEmail = this.validateEmail.bind(this);
        this.validatePhone = this.validatePhone.bind(this)
        // this.changePinCodeFormValidState = this.changePinCodeFormValidState.bind(this);
    }

    handleNameChange(e) {
        this.setState({ Name: e });
        // this.setState({Name: this.state.Name.charAt(0).toUpperCase() + this.state.Name.slice(1)});
    }
    handleBTagChange(e) {
        this.setState({ bTag: e })
    }
    handleSurNameChange(e) {
        this.setState({ Surname: e });
        // this.setState({Surname: this.state.Surname.charAt(0).toUpperCase() + this.state.Surname.slice(1)});
    }
    handleCnpChange(e) {
        this.setState({ CNP: e });
    }
    handlePhoneChange(e) {
        e.length <= 10 && this.setState({ Phone: e });
    }
    handleEmailChange(e) {
        this.setState({ Email: e });
    }
    handleChecked(e) {
        this.setState({ isChecked: !this.state.isChecked });
    }

    // changePinCodeFormValidState(isPinCodeFormValid) {
    //     this.setState({ isPinCodeFormValid });
    // }

    registerPopupForDms() {
        return () => {
            this.props.closePopup()();
            this.props.dispatch(RegisterMode(false));
            this.props.dispatch(ClearCardRegistered());
        };
    }

    isFormValid() {
        return Object.keys(this.state).every(item => !!this.state[item]);
    }

    isInputValid(name, surname, phone, email) {
        const letters = /^(?!.*([QqWw])|.*([A-Za-z])\2{2})[A-Za-z]+$/i;
        return (name.length >= 3 && surname.length >= 3 && name.match(letters) !== null && surname.match(letters) !== null && phone.length >= 10);
    }
    validateEmail(email) {
        return String(email)
            .toLowerCase()
            .match(
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            );
    };

    validatePhone(phone) {
        const valPhone = /^[0-9]{10,10}$/;
        return valPhone.test(phone)
    }

    confirmRegistration() {
        return () => {

            let registerRfid = this.props.isCardRegistered.id,
                inputfields = this.state;
            inputfields.Name = Helpers.MakeLetterCapitalize(inputfields.Name);
            inputfields.Surname = Helpers.MakeLetterCapitalize(inputfields.Surname);

            let inputData = JSON.stringify({ ...inputfields, CardId: registerRfid });
            let token = JSON.parse(sessionStorage.getItem("authData")).token;

            Zergling.get({ "token": token, "filter": { "document_number": this.state.CNP } },
                "terminal_find_player")
                .then(response => {
                    if (response.data.length === 0) {
                        this.props.dispatch(ConfirmRegistrationNewCard(inputData)); // then will call registrFromCSharp
                    } else if (response.data.length !== 0 && response.data[0].DocNumber === this.state.CNP) {
                        let updateData = ({ ...JSON.parse(inputData), Id: response.data[0].Id });
                        this.props.closePopup()();
                        this.props.dispatch(OpenPopup("dmsRegUpdateConfirmation", updateData));
                    }
                });
        };
    }

    render() {
        return Template.default.apply(this); //eslint-disable-line no-undef
    }
}

const mapStateToProps = (_) => {
    let tid = JSON.parse(sessionStorage.getItem('authData')).tid;
    return createSelector(
        [
            state => state.swarmData.data.terminal_balance && state.swarmData.data.terminal_balance.terminals[tid] && state.swarmData.data.terminal_balance.terminals[tid].balance,
            state => state.betslip.events && Object.keys(state.betslip.events),
            state => state.terminal.isAdminLoggedIn,
            state => state.terminal.isCardRegistered,
            state => state.terminal.cardRegistered

        ],
        (terminalBalance, betslipEvents, isAdminLoggedIn, isCardRegistered, cardRegistered) => {
            return {
                terminalBalance,
                betslipEvents,
                isAdminLoggedIn,
                isCardRegistered,
                cardRegistered
            };
        }
    );
};

DmsRegisterFields.propTypes = {
    data: PropTypes.object,
    closePopup: PropTypes.func,
    openPopup: PropTypes.func,
    terminalBalance: PropTypes.number,
    isCardRegistered: PropTypes.number,
    cardRegistered: PropTypes.bool
};

export default connect(mapStateToProps)(UIMixin({ Component: DmsRegisterFields }));
